import { TimeZones } from 'generated/graphql-types';
import {
   createEagerSelectAdapter,
   createEagerSelectReducer,
   EagerSelectState,
} from '../../select/eager-select/eager-select-reducer';
import { TimeZoneOption } from '../models/time-zone-option';
import { timeZoneOptionActions } from './time-zone-option.actions';

export const timeZoneOptionFeatureKey = 'timeZoneOptions';

export type TimeZoneOptionState = EagerSelectState<TimeZoneOption>;

const adapter = createEagerSelectAdapter<TimeZoneOptionState, TimeZoneOption>({
   featureKey: timeZoneOptionFeatureKey,
   selectId: (timeZone: TimeZoneOption) => {
      return timeZone.timeZoneId ? timeZone.timeZoneId : '';
   },
});

export const timeZoneOptionSelectors = adapter.getSelectors(filterTimeZoneNameOption);

const initialState = adapter.getInitialState();

export const timeZoneTypeOptionsReducer = createEagerSelectReducer(
   adapter,
   initialState,
   timeZoneOptionActions.search,
   timeZoneOptionActions.searchReset,
   timeZoneOptionActions.loadFromApi,
   timeZoneOptionActions.loadFromApiSuccess,
   timeZoneOptionActions.loadFromApiFailure
);

export function filterTimeZoneNameOption<T extends TimeZoneOption>(
   types: T[],
   searchText: string | null | undefined
): T[] {
   const filteredOptions: T[] = Object.values(TimeZones)
      .filter((timeZone) => {
         if (searchText) {
            return timeZone.toLowerCase().includes(searchText.toLowerCase());
         } else {
            return true;
         }
      })
      .map((timeZoneId) => {
         return { timeZoneId } as T;
      });

   return filteredOptions;
}
